import React from "react";
import { Typography } from "@mui/material";
import { FaLeaf } from "react-icons/fa";
import useSystemVariable from "./shared/useSystemVariable";
import SystemVariablePage from "./shared/SystemVariablePage";
import ChoiceChipGroup from "../../components/atoms/ChoiceChipGroup";
import { COLORS, TYPO } from "../../styles/uiConstants";
import {
  useListTraditionalPracticesMutation,
  useCreateTraditionalPracticeMutation,
  useUpdateTraditionalPracticeMutation,
  useDeleteTraditionalPracticeMutation,
} from "../../store/traditionalApi";

const CONSENT_OPTIONS = [
  { value: "yes", label: "Onam gerekir" },
  { value: "no", label: "Gerekmez" },
];

const ConsentChoice = (form, setField) => (
  <ChoiceChipGroup
    options={CONSENT_OPTIONS}
    value={form.requiresConsent ? "yes" : "no"}
    onChange={(v) => setField("requiresConsent", v === "yes")}
    ariaLabel="Onam gerekliliği"
    sx={{ mt: 0.75 }}
  />
);

const Muted = ({ children }) => (
  <Typography component="span" sx={{ fontSize: TYPO.body, color: COLORS.slate500 }}>
    {children}
  </Typography>
);

/**
 * Sistem değişkeni: Geleneksel uygulama türleri (Hacamat, Sülük, Kupa…).
 * Uyarı anahtar kelimeleri seans açılırken hastanın kronik hastalık, alerji ve
 * aktif ilaçlarıyla karşılaştırılır (ör. "antikoagülan" → Coumadin).
 */
export default function TraditionalPractices() {
  const vm = useSystemVariable({
    listMutation: useListTraditionalPracticesMutation(),
    createMutation: useCreateTraditionalPracticeMutation(),
    updateMutation: useUpdateTraditionalPracticeMutation(),
    deleteMutation: useDeleteTraditionalPracticeMutation(),
    itemsKey: "items",
    idKey: "practiceId",
    defaultForm: { name: "", requiresConsent: false, cautions: "" },
    itemToForm: (it) => ({
      name: it?.name || "",
      requiresConsent: Boolean(it?.requiresConsent),
      cautions: (it?.cautions || []).join(", "),
    }),
    formToPayload: (form) => ({
      name: form.name,
      requiresConsent: Boolean(form.requiresConsent),
      cautions: String(form.cautions || ""),
    }),
    entityLabel: "Uygulama",
    storageKey: "TraditionalPractice",
  });

  const fields = [
    { key: "name", label: "Uygulama adı", required: true },
    { key: "requiresConsent", label: "Onam", render: ConsentChoice },
    { key: "cautions", label: "Uyarı anahtar kelimeleri (virgülle ayırın)", multiline: true },
  ];

  return (
    <SystemVariablePage
      icon={<FaLeaf size={22} />}
      title="Geleneksel Uygulamalar"
      subtitle="Seans kaydında seçilen uygulama türleri; onam ve uygunluk uyarısı ayarları"
      entityLabel="Uygulama"
      vm={vm}
      tableColumns={[
        { key: "name", label: "Uygulama", bold: true, width: "28%" },
        {
          key: "requiresConsent",
          label: "Onam",
          width: "18%",
          render: (it) => (it?.requiresConsent ? "Gerekir" : <Muted>Gerekmez</Muted>),
        },
        {
          key: "cautions",
          label: "Uyarı anahtar kelimeleri",
          render: (it) => ((it?.cautions || []).length ? it.cautions.join(", ") : <Muted>—</Muted>),
        },
      ]}
      formFields={fields}
    />
  );
}
